import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

import { MessageComponent } from '../Preview/MessageComponents';

import { FieldWrapper, SuccessMessage } from './components';

interface ConsentSuccessContentProps {
  isOnlinePayment: boolean;
}
export const ConsentSuccessContent = ({
  isOnlinePayment,
}: ConsentSuccessContentProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.explicitConsent',
  });

  return (
    <FieldWrapper>
      <MessageComponent
        icon={
          <CheckCircleOutlineIcon sx={{ color: '#0051ff', fontSize: '40px' }} />
        }
        title={
          isOnlinePayment
            ? t('successConsent.payment')
            : t('successConsent.consent')
        }>
        <SuccessMessage>{t('successConsent.content')}</SuccessMessage>
      </MessageComponent>
    </FieldWrapper>
  );
};
